import type { LoginProblem } from '@brimstone/shared';
import { useSearchParams } from 'react-router';
import { Wordmark } from '../components/AppShell';
import { Panel } from '../components/ui';

const MESSAGES: Record<LoginProblem | 'loggedOut' | 'none', { title: string; body: string }> = {
  none: { title: 'Log in', body: 'Brimstone uses your Chestrose account.' },
  loggedOut: { title: 'You’re logged out', body: 'Log in again with your Chestrose account.' },
  not_allowed: {
    title: 'Not allowed',
    body: 'This Chestrose account isn’t the one Brimstone belongs to. Log in to Chestrose as the owner and try again.',
  },
  no_token: {
    title: 'Couldn’t log you in',
    body: 'Chestrose didn’t send a login back. Try again in a moment.',
  },
  unconfigured: {
    title: 'Chestrose login isn’t available here',
    body: 'Chestrose can only log you in on brimstone.chestrose.com. For local development set AUTH_DEV_USER.',
  },
};

function problemFrom(params: URLSearchParams): keyof typeof MESSAGES {
  const error = params.get('error');
  if (error === 'not_allowed' || error === 'no_token' || error === 'unconfigured') return error;
  if (params.get('loggedOut') === '1') return 'loggedOut';
  return 'none';
}

/** Where /auth/login sends a browser it couldn't log in, and where logging out lands. */
export function LoginPage() {
  const [params] = useSearchParams();
  const message = MESSAGES[problemFrom(params)];
  return (
    <>
      <header className="border-b border-line bg-header">
        <div className="mx-auto flex min-h-[60px] max-w-[1280px] items-center px-4 sm:px-6">
          <Wordmark />
        </div>
      </header>
      <main className="mx-auto max-w-[480px] px-4 py-10 sm:px-6">
        <Panel title={message.title}>
          <p className="m-0 px-4 pt-4 text-body">{message.body}</p>
          <div className="px-4 py-4">
            <a
              href="/auth/login"
              className="inline-flex min-h-11 items-center border border-accent px-4 font-mono text-compact font-semibold text-accent no-underline"
            >
              Log in with Chestrose
            </a>
          </div>
        </Panel>
      </main>
    </>
  );
}
